import { GarantiasResInterface } from '../interfaces/garantias-res.interface';

export class GarantiasResModel {
  idGarantia: number;
  idProducto: number;
  impLimite: number;
  impLimiteMaximo: number;
  impTramoLimite: number;
  indLimiteOpcional: boolean;
  indOpcional: boolean;
  literal: string;
  num_opcion_Contratacion: number;
  selectedExtend?;
  descripcionWeb: string;

  constructor( obj: GarantiasResInterface) {
    this.idGarantia = obj && obj.IdGarantia;
    this.idProducto = obj && obj.IdProducto;
    this.impLimite = obj && obj.ImpLimite;
    this.impLimiteMaximo = obj && obj.ImpLimiteMaximo;
    this.impTramoLimite = obj && obj.ImpTramoLimite;
    this.indLimiteOpcional = obj && obj.IndLimiteOpcional;
    this.indOpcional = obj && obj.IndOpcional;
    this.literal = obj && obj.Literal;
    this.num_opcion_Contratacion = obj && obj.Num_opcion_Contratacion;
    this.descripcionWeb = obj && obj.DescripcionWeb;
  }
}
